import { REACT_APP_LAUNCH_SCRIPWARE_URL } from 'common/env';
import { Routes } from 'routes';

export const getPendingOrdersUrl = (isScripware: boolean) =>
    isScripware ? REACT_APP_LAUNCH_SCRIPWARE_URL || '' : Routes.CoordinatorDashboardOrderQueue;

export const getPendingPurchaseOrderCountUrl = (isScripware: boolean) =>
    isScripware ? REACT_APP_LAUNCH_SCRIPWARE_URL || '' : Routes.CoordinatorDashboardPOManager;
